import { BOOLEAN_FACETS_MAPPING_VALUE } from 'components/SA/Facets/helpers/constants'
import { getParamsToGenerateURL } from '../../selectors/facets'
import { generateLocationUrl } from 'components/SA/Facets/helpers/url'

export const getHrefFunction = (state) => {
  const { queryParams, pathParams, sharedFacetNames } = getParamsToGenerateURL(state)
  // We want a way to create pass in PARAMS and create UNIQUE url
  return (params): string => {
    return generateLocationUrl({
      queryParams: { ...queryParams, ...(params || {}) },
      // Params are OVERRIDES to create URL
      pathParams,
      sharedFacetNames,
      booleanFacetsObject: BOOLEAN_FACETS_MAPPING_VALUE,
    })
  }
}
